<p style="text-align: center;margin: 0 auto 0;font-weight: bold;font-size: 30px;">{{'messages.redirecting' | translate}}</p>
